import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import { rem } from 'design-system/values';
import { SettingsItemIcon } from 'design-system/SettingsItemIcon';
import Text, { lineHeight } from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
export const SettingsItemCard = memo(({ icon, title, description, onPress, onLight, style, testID, compactText, descriptionMaxLines, }) => {
    const styles = useStyles(styleSet);
    const descriptionStyle = useMemo(() => descriptionMaxLines
        ? { minHeight: rem(lineHeight.TextThin_14 * descriptionMaxLines) }
        : undefined, [descriptionMaxLines]);
    return (<TouchableBounceCard noMargin {...(onLight ? { onLight: true } : { onDark: true })} style={[styles.container, style]} onPress={onPress} disabled={!onPress} testID={testID}>
        <SettingsItemIcon light={onLight} style={styles.squircle}>
          {icon}
        </SettingsItemIcon>
        <View style={!compactText && styles.textContainer}>
          {typeof title === 'string' ? <Text Text-16>{title}</Text> : title}
          {typeof description === 'string' ? (<Text TextThin-14 Secondary numberOfLines={descriptionMaxLines} style={descriptionStyle}>
              {description}
            </Text>) : (description ?? null)}
        </View>
      </TouchableBounceCard>);
});
const styleSet = createStyleSheets(() => ({
    container: {
        padding: rem(16),
        flex: 1,
    },
    textContainer: {
        gap: rem(4),
    },
    squircle: {
        marginBottom: rem(16),
    },
}));
